import { Body, Button, colors, Image, Spacer } from '@spritz-finance/ui'
import { useNavigate } from 'react-router-dom'
import { Column } from '../../../../components/Layout/Column'
import { ThemedHeroImage } from '../../../../components/ThemedHeroImage'

export const NoTransfersInProgress = () => {
    const navigate = useNavigate()
    return (
        <Column align="center">
            <Spacer height={48} />
            <Body.SmBold size={16} secondary>
                No transfers in progress
            </Body.SmBold>
            <Spacer height={16} />
            <Body.SmBold size={14} color={colors.medGrey}>
                Once you make a transfer, it will show up here until it settles in your account
            </Body.SmBold>
            <Spacer height={48} />
            <ThemedHeroImage>
                <Image.SchedulePayment width={300} />
            </ThemedHeroImage>
            <Spacer height={48} />
            <Button.CTA onClick={() => navigate('/offramp')}>Go to accounts</Button.CTA>
        </Column>
    )
}
